import { connect } from 'react-redux';
import Footer from './Footer';

const mapStateToProps = ({ content: { footer }, system: { isMobile, siteName }}) => ({
  data: footer,
  isMobile,
  site: siteName
});

export default connect(mapStateToProps, null)(Footer);
